// extracted by mini-css-extract-plugin
export default {"authContainer":"style_authContainer__HBUnR"};